import {
  type OfferV11,
  OfferV1NowProductGroupEnum,
} from '@redteclab/api/clients/bully'

import { productAccessorIsSaeOffer } from './productAccessorIsSaeOffer'

export const productAccessorOfferNowProductGroupIsSameDayNextDay = (
  offer: OfferV11,
): boolean => {
  if (!productAccessorIsSaeOffer(offer)) {
    return false
  }

  return offer.nowProductGroup === OfferV1NowProductGroupEnum.SamedayNextday
}
